export const USER_STATUS = {
  active: 'active',
  invited: 'invited',
  suspended: 'suspended',
};

export const USER_ROLE = {
  ADMIN: 'ADMIN',
  WHOA_GUIDE: 'WHOA_GUIDE',
};

export const EXPERIENCE_CATEGORIES = [
  { label: 'Scavenger Hunts', value: 'treasure_hunt' },
  { label: 'Guided Tours', value: 'guided_tour' },
  { label: 'Food Adventures', value: 'food_hunt' },
  { label: 'Date Nights', value: 'date_night' },
  { label: 'Drink Adventures', value: 'drink_tour' },
  { label: 'Nature Adventures', value: 'nature_tour' },
  { label: 'Games', value: 'game' },
];

export const EXPERIENCE_THEMES = [
  { label: 'Art', value: 'art' },
  { label: 'Architecture', value: 'architecture' },
  { label: 'History', value: 'history' },
  { label: 'Food & Drink', value: 'food' },
  { label: 'Music', value: 'music' },
  { label: 'Park', value: 'park' },
  { label: 'Kid-Friendly', value: 'kid_friendly' },
  { label: 'Neighborhood', value: 'neighborhood' },
  { label: 'Culture', value: 'culture' },
  { label: 'Sports', value: 'sports' },
  { label: 'Miscellaneous', value: 'miscellaneous' },
  { label: 'Macombopoly', value: 'macombopoly', category: 'game' },
];

export const EXPERIENCE_STATUS_LABEL = {
  incomplete: 'incomplete',
  draft: 'Draft',
  pending: 'Pending',
  published: 'Published',
  reviewed: 'Reviewed',
};

export const EXPERIENCE_STATUS = {
  INCOMPLETE: 'incomplete',
  DRAFT: 'draft',
  PENDING: 'pending',
  PUBLISHED: 'published',
  REVIEWED: 'reviewed',
};

export const DEFAULT_COUNTRY_INFO = {
  name: 'United States',
  countryCode: 'US',
};

export const WEEKS_NAMES = [
  { label: 'Sunday', value: 'sun' },
  { label: 'Monday', value: 'mon' },
  { label: 'Tuesday', value: 'tue' },
  { label: 'Wednesday', value: 'wed' },
  { label: 'Thursday', value: 'thu' },
  { label: 'Friday', value: 'fri' },
  { label: 'Saturday', value: 'sat' },
];

export const DEFAULT_INCLUDE_POPUP = 'no';
